const defaultNavItems = [
  { key: "home", label: "Home", icon: "/logos/home.svg", path: "/" },
  { key: "purchase-orders", label: "Purchase orders", icon: "/logos/document.svg", path: "/po/list" },
  { key: "plan-shipment", label: "Plan shipment", icon: "/logos/truck-outline.svg", path: "/plan-shipment" },
  { key: "grn-payments", label: "GRN & payments", icon: "/logos/currency-inr.svg", path: "/grn/list" },
  { key: "direct-delivery", label: "Direct delivery", icon: "/logos/package.svg", path: "/ddPo/all" },
  { key: "bidding", label: "Bidding", icon: "/logos/gavel.svg", path: "/bids/all" },
  { key: "manage-users", label: "Manage users", icon: "/logos/users.svg", path: "/manage-users" },
  { key: "packaging-labels", label: "Packaging labels", icon: "/logos/sticker.svg", path: "/download-labels" },
];

export default defaultNavItems;
